module.exports = __webpack_public_path__ + "img/traffic-light.e239ce66.svg";